import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';

import { PaymentMethod, PaymentsError, Transaction, } from '@fry/payments/lib';
import { TracksOperationProgress } from '@fry/components/common';
import { MatSelectChange } from '@angular/material/select';

/**
 * Payment details & Payment method
 *
 * This components shows the details of the payment to the user and allows
 * user to select payment method they wish to use.
 *
 * When there is only one payment method allowed for the transaction this
 * component is displaying, component will automatically set the method and exit
 * to allow the payment workflow to transition to the next state.
 */
@Component({
    selector: 'eas-payments-details',
    templateUrl: './transaction.details.component.html',
    standalone: false
})
export class TransactionDetailsComponent implements OnInit, AfterViewInit, TracksOperationProgress {

    @Input() isOperationInProgress = false;
    @Input() transaction!: Transaction;
    @Output() attempt = new EventEmitter<void>();
    @Output() error = new EventEmitter<Error>();

    public availablePaymentMethodsControl = new UntypedFormControl('', [Validators.required]);
    public availablePaymentMethods: PaymentMethod[] = [];

    public constructor() { }

    public ngOnInit() {
        this.availablePaymentMethods = this.transaction.availableMethods;
        if (this.transaction.method) {
            this.availablePaymentMethodsControl.setValue(this.transaction.method.id);
        }
    }

    public ngAfterViewInit() {
        if (this.availablePaymentMethods.length === 0) {
            this.error.emit(new PaymentsError($localize `No Available payment methods configured for the Transaction!`));
        }
        // Auto transition when single payment method
        if (this.availablePaymentMethods.length === 1) {
            this.handleMethodChange(this.availablePaymentMethods[0].id);
            this.onClicked();
        }
    }

    public onClicked() {
        this.attempt.emit();
    }

    public onSelectValueChange(change: MatSelectChange) {
        this.handleMethodChange(change.value);
    }

    private handleMethodChange(methodID: string) {
        const method = this.availablePaymentMethods.find(pm => pm.id === methodID);
        if (!method) {
            throw new PaymentsError($localize `Invalid Payment method ID (${methodID}) or invalid configuration of Available Payment methods.`);
        }
        this.transaction.method = method;
    }
}
